export default __webpack_public_path__ + "static/media/icon.share.b121a7c4.svg";